import React, { useState, useEffect } from "react";
import {
    Container,
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardMedia,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Chip,
    Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import VerifiedIcon from '@mui/icons-material/Verified';
import Footer from '../core/Footer';
import BadgeCard from '../awards/components/BadgeCard';
import { getBadges } from '../awards/apiBadge';

const Awards = () => {
    const [expanded, setExpanded] = useState('panel1');
    const [digitalBadges, setDigitalBadges] = useState([]);

    useEffect(() => {
        getBadges().then(data => {
            if (data && !data.error) {
                setDigitalBadges(data);
            }
        });
    }, []);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const awards = [
        {
            id: 'panel1',
            badgeTypeId: 'paragon',
            title: 'The SDSIC Paragon Award',
            icon: <EmojiEventsIcon sx={{ fontSize: 48, color: '#FF6600' }} />,
            color: '#FF6600',
            image: '/images/Paragon.jpg',
            description: [
                'The SDSIC Paragon award was designed to honor the unparalleled dedication and exceptional work ethic of an outstanding individual within our organization. This award celebrates not just the contribution but the spirit of collaboration, inclusivity, and unwavering support that fuels the growth and momentum of SDSIC.',
                'Each year, we seek to spotlight a remarkable member of our team who goes above and beyond in assisting our non-profit organization, demonstrating an exceptional commitment to helping members, fostering a collaborative culture, and significantly contributing to our collective mission. The recipient of the SDSIC Paragon Award embodies the very essence of leadership, teamwork, and community engagement, making a tangible impact on our organization\'s progress and success.',
                'The award serves as a beacon of excellence, encouraging all members of SDSIC to aspire towards greatness, promote unity, and work tirelessly towards our common goals. Through this recognition, we not only celebrate individual achievement but also reinforce our commitment to building a supportive, dynamic, and inclusive environment where everyone thrives together.'
            ],
            winners: [
                // {
                //     year: '2024',
                //     name: 'Scott Dimpfl',
                //     company: 'American Electric Power',
                //     link: 'https://sdsconsortium.com/user/6091653ca6e6f139835b6bb2',
                //     linkType: 'profile',
                //     image: '/images/2024_paragon.png'
                // },
                // {
                //     year: '2023',
                //     name: 'Audrey Marich',
                //     company: 'PPL Electric Utilities',
                //     link: 'https://www.linkedin.com/in/audrey-marich-273431194/',
                //     linkType: 'linkedin',
                //     image: '/images/AudreyAward.png'
                // },
                // {
                //     year: '2022',
                //     name: 'Trevor Scullion',
                //     company: 'SDSIC Advisor',
                //     link: 'https://www.linkedin.com/in/tscullion/',
                //     linkType: 'linkedin',
                //     image: '/images/ParagonTscullion.jpg'
                // }
            ]
        },
        {
            id: 'panel2',
            badgeTypeId: 'david_milks_memorial',
            title: 'The David H. Milks SDSIC Memorial Award',
            icon: <AutoAwesomeIcon sx={{ fontSize: 48, color: '#003E7E' }} />,
            color: '#003E7E',
            image: '/images/davidPic.jpg',
            description: [
                'This award honors the memory of David Milks, a founding member of the SDS Industry Consortium (SDSIC). David came up with the initial consortium concept, which established a forum for substation design professionals to provide guidance and influence the electric utility industry\'s transition and adoption of intelligent, 3D substation software design tools. While serving in his industry leadership role at Autodesk, David cowrote the initial SDSIC bylaws, established financial sponsorships to fund SDSIC events, and he worked tirelessly for many years to grow the SDSIC community.',
                'After his passing on August 14, 2019, the David H. Milks SDSIC Memorial Award was established to serve as a lasting tribute to David and recognize those in our community that have made extraordinary contributions towards advancing the SDS Industry Consortium throughout the year as voted on by the SDSIC members.'
            ],
            winners: [
                {
                    year: '2024',
                    name: 'Bill Gordon',
                    company: 'Transmission Engineering group, Southern Company',
                    link: 'https://www.linkedin.com/in/william-gordon-934785170/',
                    linkType: 'linkedin',
                    image: '/images/2024_milks.png'
                },
                {
                    year: '2023',
                    name: 'Jeff Spence',
                    company: 'VP of Strategic Innovations, Ampirical Solutions, LLC',
                    link: 'https://www.linkedin.com/in/jeffrey-spence-1720a73b/',
                    linkType: 'linkedin',
                    image: '/images/JeffsAward.png'
                },
                {
                    year: '2022',
                    name: 'Mark Nelson',
                    company: 'Idaho Power and our SDSIC co-Chair',
                    link: 'https://www.linkedin.com/in/mark-nelson-89a78320/',
                    linkType: 'linkedin',
                    image: '/images/nelson2022.jpg'
                },
                {
                    year: '2021',
                    name: 'Arnold Fry',
                    company: 'PE, MBA, POWER Engineers',
                    link: 'https://www.linkedin.com/in/arnold-fry-pe-mba-193a3b15b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BCDI5lhEVTremj8kIjpzhaA%3D%3D',
                    linkType: 'linkedin',
                    image: '/images/ArnoldAWard2.JPG'
                },
                {
                    year: '2020',
                    name: 'Audrey Marich',
                    company: 'PPL Corporation and SDSIC Chair',
                    link: 'https://www.linkedin.com/in/audrey-marich-13a86b1b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B2%2FTQQVCLTziDV5FFB5nqug%3D%3D',
                    linkType: 'linkedin',
                    image: '/images/DHM-award-2020.png'
                }
            ]
        },
        {
            id: 'panel3',
            badgeTypeId: 'dan_gerlach_innovation',
            title: 'The Dan Gerlach SDSIC Innovation Award',
            icon: <LightbulbIcon sx={{ fontSize: 48, color: '#FF6600' }} />,
            color: '#FF6600',
            image: '/images/Daniel-Gerlach.jpg',
            description: [
                'This award honors Dan Gerlach, a founding member of the SDS Industry Consortium (SDSIC). Dan architected and developed the original 3D Substation Design Tools which continue to be adopted by our industry designers today. At Automationforce, Dan helped change the substation design industry with his innovative ideas year after year for 12+ years until he retired in 2019.',
                'Dan passed away on January 9th, 2022, after a long battle with cancer and the SDSIC established the Dan Gerlach Innovation Award to serve as a lasting tribute to Dan and recognize those in our community that have made the most innovative contributions to our industry throughout the year as voted on by the SDSIC members.'
            ],
            winners: [
                {
                    year: '2024',
                    name: 'Nate Holt',
                    company: 'The Father of AutoCAD Electrical',
                    link: 'https://www.linkedin.com/in/nate-holt-pe-254034a',
                    linkType: 'linkedin',
                    image: '/images/2024_gerlach.png'
                },
                {
                    year: '2023',
                    name: 'Michael Bussinger',
                    company: 'Assistant Department Manager at Burns & McDonnell',
                    link: 'https://www.linkedin.com/in/michael-bussinger-58179480/',
                    linkType: 'linkedin',
                    image: '/images/MichaelsAWard.png'
                },
                {
                    year: '2022',
                    name: 'Steve Kaufman',
                    company: 'SBS',
                    link: 'https://www.linkedin.com/in/stephen-kaufman-96246245/',
                    linkType: 'linkedin',
                    image: '/images/steveaward.jpg'
                }
            ]
        }
    ];

    return (
        <>
            {/* Hero Section */}
            <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 6, mb: 4 }}>
                <Container maxWidth="lg">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                        <EmojiEventsIcon sx={{ fontSize: 64 }} />
                        <Box>
                            <Typography variant="h2" component="h1" sx={{ fontWeight: 700, mb: 0.5 }}>
                                SDSIC Awards
                            </Typography>
                            <Typography variant="h5" sx={{ opacity: 0.9 }}>
                                Celebrating Excellence, Innovation & Leadership
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>

            <Container maxWidth="lg" sx={{ mb: 6 }}>
                {/* Awards Accordions */}
                {awards.map((award) => (
                    <Accordion
                        key={award.id}
                        expanded={expanded === award.id}
                        onChange={handleChange(award.id)}
                        elevation={3}
                        sx={{
                            mb: 3,
                            borderRadius: 3,
                            overflow: 'hidden',
                            '&:before': {
                                display: 'none',
                            },
                            '&.Mui-expanded': {
                                margin: '0 0 24px 0',
                            }
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ fontSize: 32, color: award.color }} />}
                            sx={{
                                backgroundColor: expanded === award.id ? award.color : 'rgba(0, 62, 126, 0.02)',
                                color: expanded === award.id ? 'white' : '#003E7E',
                                minHeight: 80,
                                '&.Mui-expanded': {
                                    minHeight: 80,
                                },
                                '& .MuiAccordionSummary-content': {
                                    alignItems: 'center',
                                    gap: 2,
                                    my: 2
                                },
                                transition: 'all 0.3s ease'
                            }}
                        >
                            {React.cloneElement(award.icon, {
                                sx: {
                                    fontSize: 48,
                                    color: expanded === award.id ? 'white' : award.color
                                }
                            })}
                            <Typography variant="h4" sx={{ fontWeight: 600 }}>
                                {award.title}
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ p: 4 }}>
                            {/* Award Description with Image */}
                            <Grid container spacing={4} sx={{ mb: 5 }}>
                                <Grid item xs={12} md={8}>
                                    <Typography variant="h5" sx={{ fontWeight: 600, color: award.color, mb: 3 }}>
                                        About This Award
                                    </Typography>
                                    {award.description.map((paragraph, idx) => (
                                        <Typography
                                            key={idx}
                                            variant="body1"
                                            sx={{ mb: 2, lineHeight: 1.8, fontSize: '1.05rem' }}
                                        >
                                            {paragraph}
                                        </Typography>
                                    ))}
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper
                                        elevation={4}
                                        sx={{
                                            borderRadius: 3,
                                            overflow: 'hidden',
                                            border: `4px solid ${award.color}`
                                        }}
                                    >
                                        <img
                                            src={award.image}
                                            alt={award.title}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                display: 'block'
                                            }}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>



                            <Grid container spacing={3}>
                                {award.winners.map((winner, idx) => (
                                    <Grid item xs={12} sm={6} md={4} key={idx}>
                                        <Card
                                            elevation={2}
                                            sx={{
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                borderRadius: 3,
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    transform: 'translateY(-8px)',
                                                    boxShadow: `0 12px 24px ${award.color}40`,
                                                }
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                image={winner.image}
                                                alt={`${winner.name} - ${winner.year}`}
                                                sx={{
                                                    height: 300,
                                                    objectFit: 'cover',
                                                    borderBottom: `4px solid ${award.color}`
                                                }}
                                            />
                                            <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                                <Chip
                                                    label={winner.year}
                                                    sx={{
                                                        backgroundColor: award.color,
                                                        color: 'white',
                                                        fontWeight: 700,
                                                        fontSize: '1rem',
                                                        mb: 2
                                                    }}
                                                />
                                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E', mb: 1 }}>
                                                    {winner.name}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                    {winner.company}
                                                </Typography>
                                                <Button
                                                    href={winner.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    variant="outlined"
                                                    size="small"
                                                    endIcon={<OpenInNewIcon />}
                                                    sx={{
                                                        borderColor: award.color,
                                                        color: award.color,
                                                        '&:hover': {
                                                            borderColor: award.color,
                                                            backgroundColor: `${award.color}10`,
                                                        }
                                                    }}
                                                >
                                                    {winner.linkType === 'profile' ? 'View Profile' : 'LinkedIn'}
                                                </Button>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>

                            {/* Digital Badges for this award */}
                            {digitalBadges.filter(b => b.badgeTypeId === award.badgeTypeId).length > 0 && (
                                <>
                                    <Divider sx={{ my: 4 }} />
                                    <Box sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                            <VerifiedIcon sx={{ fontSize: 28, color: award.color }} />
                                            <Typography variant="h5" sx={{ fontWeight: 600, color: award.color }}>
                                                Digital Badges for Past Awards
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={3}>
                                            {digitalBadges
                                                .filter(b => b.badgeTypeId === award.badgeTypeId)
                                                .sort((a, b) => (b.year || 0) - (a.year || 0))
                                                .map((badge, idx) => (
                                                    <Grid item xs={12} sm={6} md={4} key={badge._id || idx}>
                                                        <BadgeCard badge={badge} />
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>
                                    </Box>
                                </>
                            )}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>

            <Footer />
        </>
    );
};

export default Awards;
